var _circle, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBall1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 458,
    height: 458,
    viewBox: "0 0 458 458",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 228.76,
    cy: 229.08,
    r: 228.26,
    stroke: "url(#paint0_linear_76_124)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_76_124",
    x1: 343.14,
    y1: 371.942,
    x2: 146.992,
    y2: 74.4217,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#13ADC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.666667,
    stopColor: "#6978D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#945DD6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBall1);
export default __webpack_public_path__ + "static/media/ball1.660d98f6d861e75d7ecdd48dfa0d4a96.svg";
export { ForwardRef as ReactComponent };